<ng-container *transloco="let t; read: 'partials.backbutton'">
  <div>
    <button pButton type="button" (click)="close()" icon="pi pi-times" class="p-button-secondary p-button-text" [pTooltip]="t('back_to_angenda')"  tooltipPosition="left"></button>
  </div>
</ng-container>
